import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            主题索引
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            每日大赛全部话题赛道分类，快速找到你感兴趣的创作方向
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {indexItems.map((item, idx) => (
              <a
                key={idx}
                href="#carousel"
                className="flex items-center gap-3 p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200/50 transition-colors cursor-pointer no-underline group"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors flex-shrink-0">
                  <i className={`${item.icon} text-primary-600 text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500">{item.count}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}